<template>
  <DBox
    :id="'cmp-catalog-artist-sidewindow-default_credit'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new_credits')"
    @add_click="onAddCredit"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-related-genres"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('type')">
            <span>{{ item["type"] }}</span>
          </td>

          <td v-bind="tdcon('name')">
            <span>{{ item["name"] }}</span>
          </td>
          <td v-bind="tdcon('percentage')">
            <span class="txtov text-right" :title="item['percentage']">{{
              item["percentage"]
            }}</span>
          </td>
          <td v-bind="tdcon('option')">
            <div class="dt-icon-container">
              <img
                @click.stop="e => deleteCredit(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s2"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    selectedArtistDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight:true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("type", { text: "type" }),
        createTableHeader("name", {}),
        createTableHeader("percentage", { ta: "right", mw: 100 }),
        createTableHeader("option", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedArtistDetails.default_credits || [];
    }
  },
  methods: {
    onTextFieldValueChange: function() {},
    onDropdownChange: function(item, e) {
      console.log("ITEM GENRE ENK", e);
      const payload = {
        name: "genre_relation_rank",
        value: e.value,
        item: item
      };

      this.$emit("change", payload);
    },
    onDateChange: function() {},
    deleteGenre: function(item) {
      const payload = {
        genre_id: item.genre_id,
        genre_relation_id: item.genre_relation_id
      };
      this.$emit("delete", payload);
      console.log("Genres", item);
    },
    onAddCredit: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_default_credit",
          external_id: this.selectedArtistDetails.artist.label_artist_id
        }
      });
    },

    deleteCredit: function(payload) {
      this.$emit("delete", payload);
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-artist-sidewindow-default_credit {
  .dt-ntable {
    --ntable-height: 170px;
  }
}
</style>
